import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'seb-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css']
})
export class ProgressBarComponent implements OnInit {
  @Input() label: String;
  @Input() percentage: String;
  @Input() backgroundColor: String;
  @Input() value: String | Number;
  @Input() showPercentage: Boolean;
  @Input() progressBarHeight: Number;

  constructor() {}

  ngOnInit() {}

}
